import React from 'react';

import { ModalFormHeader } from '.';

interface LifeSaverFormProps {
  icon: string;
  header: string;
  children?: React.ReactNode;
  step?: number;
  steps?: number;
}

export function LifeSaverForm({ 
  icon, 
  header, 
  children = null,
  step = null,
  steps = null
}: LifeSaverFormProps) {
  return (
    <div className="form-container">
      <ModalFormHeader
        icon={icon}
        header={header}
        step={step}
        steps={steps}
      />
      {children}
    </div>
  );
}
